module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/credit-card-fc62766b256983461a6e5c1ee6cf39a7.svg";